import { Typography } from "@material-ui/core";
import { Trans } from "react-i18next";
import Flex from "components/grid/Flex";
import { isExplicitlyChosen } from "../../HistoryUtils";

const ConditionalLabel = ({ value, label, style, noDetails, indent }) => {
    return isExplicitlyChosen(value) ? (
        <Flex item container grow={0} alignItems={"center"} style={{fontWeight: indent? 'normal': "bold",...style}}>
            {!value && (
                <Typography
                    style={{ fontWeight: "inherit", backgroundColor: "yellow", marginRight: 4 }}
                >
                    <Trans i18nKey={"global.not-any"} />
                </Typography>
            )}
            <Typography
                style={{
                    fontWeight: "inherit",
                    minWidth: 310,
                    ...(indent && {paddingLeft: 50})
                }}
            >
                {label || value}
            </Typography>
            {noDetails && (
                <Typography style={{ marginLeft: 4 }}>
                    <Trans i18nKey={"global.no-details"} />
                </Typography>
            )}
        </Flex>
    ) : (
        <></>
    );
};

export default ConditionalLabel;
